var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.lastLoginTimestamp)?_c('div',[_c('p',[_vm._v("Last login: "+_vm._s(_setup.formatDate(_setup.lastLoginTimestamp, 'yyyy-MM-dd HH:mm:ss')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }